export const ConceptType = {
    Top: "top",
    ConceptList: "concept_list",
    Specified: "specified",
    Related: "related",
    Suggested: "suggested",
    SentimentSuggested: "sentiment_suggested",
    UniqueToFilter: "unique_to_filter",
    DriversSuggested: "drivers_suggested",
};

export const ConceptTypeVolume = {
    Top: "top",
    // ConceptList: "concept_list",
    // Specified: "specified",
    // Related: "related",
    Suggested: "suggested",
    SentimentSuggested: "sentiment_suggested",
    UniqueToFilter: "unique_to_filter",
    // DriversSuggested: "drivers_suggested",
};

export const DateBreakdown = {
    INTERVALS: ["hour", "day", "week", "month", "quarter", "year"],
};

export const ShowCountOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 25, value: 25 },
];

export const MonthNames = {
    '0': "Jan",
    '1': "Feb",
    '2': "Mar",
    '3': "Apr",
    '4': "May",
    '5': "Jun",
    '6': "Jul",
    '7': "Aug",
    '8': "Sep",
    '9': "Oct",
    '10': "Nov",
    '11': "Dec",
};

export const QuarterNames = {
    0: "Q1",
    3: "Q2",
    6: "Q3",
    9: "Q4",
};
